export type Bonus = {
  n: string
  title: string
  description: string
  cover: string
}

export const bonuses: Bonus[] = [
  {
    n: '01',
    title: 'Atlas Visual de las Cinco Fases y sus Ciclos',
    description:
      'Una guía visual para estudiar Madera, Fuego, Tierra, Metal y Agua, junto con sus ciclos y correspondencias tradicionales.',
    cover:
      'https://cdn.magicpatterns.com/uploads/oFu9H247TquRhP4Q6fymjX/Atlas_visual_de_las_cinco_fases.png',
  },
  {
    n: '02',
    title: 'Glosario y Fichas de Referencia MTC Español–Pinyin',
    description:
      'Términos esenciales, pinyin, traducciones orientativas y fichas para comparar definiciones y registrar tus propias referencias.',
    cover:
      'https://cdn.magicpatterns.com/uploads/ewEiDcBMdV34gFn2chh9i7/Bonus_02__glosario_MTC_espanol%E2%80%93pinyin.png',
  },
  {
    n: '03',
    title: 'Cuaderno de Estudio, Patrones y Análisis de Casos',
    description:
      'Un cuaderno para organizar el estudio, registrar observaciones, comparar hipótesis tradicionales y trabajar casos didácticos.',
    cover:
      'https://cdn.magicpatterns.com/uploads/bhmtU1W56P22y4eacDPkDP/Cuaderno_de_casos_y_cinco_fases.png',
  },
]

export type Tome = {
  numeral: string
  label: string
  title: string
  description: string
  cover: string
}

export const tomes: Tome[] = [
  {
    numeral: '壹',
    label: 'Tomo I',
    title: 'Fundamentos de la Medicina China',
    description:
      'Yin-Yang, Qi, Jing-Luo y Cinco Fases. Un recorrido visual por conceptos esenciales y por las relaciones que dan estructura al pensamiento tradicional chino.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/6c83bd2a-71cc-4881-a769-e7365b2f7560.jpg',
  },
  {
    numeral: '貳',
    label: 'Tomo II',
    title: 'Sistemas Zang-Fu y Relaciones Funcionales',
    description:
      'Una exploración de los sistemas Zang-Fu, sus relaciones funcionales y su lugar dentro del marco tradicional de la Medicina China.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/8c14b0b4-bd3f-489f-a7fb-312dc58d01b8.jpg',
  },
  {
    numeral: '參',
    label: 'Tomo III',
    title: 'Diagnosis y Diferenciación de Patrones en MTC',
    description:
      'Un material de estudio sobre las cuatro examinaciones, los Ocho Principios y el razonamiento tradicional para organizar observaciones y comparar patrones.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/dc50bb24-a252-4239-81b8-039c32b4bf13.jpg',
  },
  {
    numeral: '肆',
    label: 'Tomo IV',
    title: 'Acupuntura y Digitopuntura: Principios y Métodos',
    description:
      'Principios generales, nomenclatura, métodos de estudio y consideraciones de seguridad para comprender mejor estas prácticas dentro del marco de la MTC.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/28ff9201-77f7-40a5-822d-97c2167f0bb0.jpg',
  },
  {
    numeral: '伍',
    label: 'Tomo V',
    title: 'Moxibustión, Ventosas y Guasha',
    description:
      'Una presentación organizada de estas modalidades, sus principios tradicionales, diferencias y consideraciones de seguridad.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/d492faa8-1964-4785-bb8e-fc2d230f4ce6.jpg',
  },
  {
    numeral: '陸',
    label: 'Tomo VI',
    title: 'Tuina, Qigong y Cultivo de la Salud',
    description:
      'Una mirada a las maniobras de Tuina, la mecánica corporal, la pedagogía del Qigong y las prácticas tradicionales de cultivo de la salud.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/bca63731-a7cd-4e1a-810a-a282f353a53c.jpg',
  },
]

export type InteriorPage = {
  title: string
  image: string
}

export const interiorPages: InteriorPage[] = [
  {
    title: 'Fundamentos y Cinco Fases',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/dafd05a7-f1f2-43f3-8dad-f90264931e7b.jpg',
  },
  {
    title: 'Sistemas Zang-Fu',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/f5c8cb3b-faac-4225-bcec-1aa76bb7e650.jpg',
  },
  {
    title: 'Diagnosis',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/77caa118-8bf0-49c8-8fd4-7619dc493ca2.jpg',
  },
  {
    title: 'Técnicas manuales y Qigong',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/51dba65e-9f35-4e18-b4fe-42d955eca031.jpg',
  },
  {
    title: 'Fichas de estudio y glosario',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d1c49d7c-6668-445d-94b3-02b43cb07221.jpg',
  },
]
